import { ReactNode, useMemo } from 'react';
import { AlertProps, Button, Flex } from 'antd';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlertsPanel.translations.json';
import {
  ValidationMessage,
  ValidationMessagesMap,
} from '../../utils/ValidationMessagesMap';
import { ErrorAlertWithDrawer } from '../../components/ErrorAlertWithDrawer';

const { addTranslations, t } = i18nNsFactory('alerts-panel');
addTranslations(translations);

/**
 * Alternate version of FormValidationAlert that isn't connected to react-hook-form
 */

export interface AlertsPanelProps extends AlertProps {
  tLabel?: (name: string | string[]) => ReactNode;
  validationMessagesMap: ValidationMessagesMap;
  errorAction?: string;
  renderErrorMeta?: (
    name: string,
    message: ValidationMessage[],
    index: number,
  ) => ReactNode;
  isErrorDrawerOpen: boolean;
  setIsErrorDrawerOpen: (isOpen: boolean) => void;
}

export const AlertsPanel = (props: AlertsPanelProps) => {
  const {
    tLabel,
    validationMessagesMap,
    errorAction,
    renderErrorMeta,
    isErrorDrawerOpen,
    setIsErrorDrawerOpen,
    ...alertProps
  } = props;

  const renderErrorHeading = useMemo(
    () =>
      tLabel &&
      ((name: string) => {
        const baseName = name.replace(/\.[0-9]+/g, '');
        return tLabel([`${baseName}.labelFull`, `${baseName}.label`]);
      }),
    [tLabel],
  );

  return (
    <ErrorAlertWithDrawer
      validationMessagesMap={validationMessagesMap}
      renderErrorHeading={renderErrorHeading}
      renderErrorMeta={renderErrorMeta}
      isErrorDrawerOpen={isErrorDrawerOpen}
      onClickDrawerClose={() => setIsErrorDrawerOpen(false)}
      onClickOpenDrawer={() => setIsErrorDrawerOpen(true)}
      errorAction={errorAction}
      drawerFooter={
        <Flex justify="end">
          <Button
            id="close-alert-panel"
            type="primary"
            onClick={() => setIsErrorDrawerOpen(false)}
          >
            {t('button.close')}
          </Button>
        </Flex>
      }
      {...alertProps}
    />
  );
};
